import NoLoginLayout from "@/components/layout/admin/NoLoginLayout.vue";
import {
    required,
    email,
    minLength
} from "vuelidate/lib/validators";
import store from "@/store";

export default {
    name: "adminLogin",
    components: {
        NoLoginLayout
    },

    data() {
        return {
            loginForm: {
                email: this.email,
                password: this.password
            },
            submitted: false
        };
    },

    validations: {
        loginForm: {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        }
    },

    methods: {
        submitLogin() {
            this.submitted = true;
            if (this.$v.loginForm.$invalid) {
                // console.log(this.$v.loginForm);
                console.log("Login validation error");
                return;
            }
            this.loginAdmin();
        },

        loginAdmin() {
            store.dispatch("adminLogin", {
                email: this.loginForm.email,
                password: this.loginForm.password,
            })
            .then(() => {
                this.$router.push({
                    name: "adminIndex"
                });
                location.reload();
            })
            .catch(error => {
                this.$notification.error("Email and Password do not match!", {
                    timer: 3,
                    position: 'bottomCenter'
                });
                console.log("login error", error);
            });
        }
    }
};